import { Typography } from '@mui/material'
import React from 'react'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import { DowngradedIdentityProps } from './_props'
import { defaultPalette } from '../../../../theme/idsTheme'
import { useFormContextPatient } from '../_utils'

const DowngradedIdentity: React.FC<DowngradedIdentityProps> = ({ displayed = true }) => {
    const { watch } = useFormContextPatient()

    const watchedManualIdentityValidation = watch('manualIdentityValidation')

    return (
        displayed &&
        !watchedManualIdentityValidation && (
            <Typography
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '.5rem',
                }}
                color={defaultPalette.red.main}
            >
                {' '}
                <WarningRoundedIcon /> <span>Identité du patient rétrogradée</span>
            </Typography>
        )
    )
}

export default DowngradedIdentity
